<template lang="pug">
  div
    app-modal.modalModelo(
      @closeModal="$emit('closeModal')"
      :titulo="titulo"
      :width="1100"
    )
      template(slot="body")
        validation-observer(ref='validation' tag='form')
          template(v-if="modeloLocal.tipoModelo === 'Modelo de Título Reurb'")
            div.campo-filtro-reurb
              div
                p Município:
                el-select.full-width.input(
                  v-model="modeloLocal.idMunicipio",
                  placeholder="Selecione o município",
                  disabled
                )
                  el-option(
                    v-for="municipio in municipiosComSelecionado",
                    :key="municipio.id",
                    :label="municipio.nome",
                    :value="municipio.id"
                  )
              div.input-reurb
                p Reurb Coletivo:
                el-select.full-width.input(
                  v-model="modeloLocal.idReurbColetivo",
                  placeholder="Selecione o Reurb Coletivo",
                  disabled
                )
                  el-option(
                    v-for="reurb in reurbColetivosComSelecionado",
                    :key="reurb.id",
                    :label="`${reurb.numeroProcesso} - ${reurb.nomeRazaoSocialInteressado}`",
                    :value="reurb.id"
                  )
              div
                p Tipo Reurb:
                el-select.full-width.input(
                  v-model="modeloLocal.tipoReurb",
                  placeholder="Selecione o tipo",
                  disabled
                )
                  el-option(label="REURB S", value="REURB_S")
                  el-option(label="REURB E", value="REURB_E")
            .group.mt-1

          div.group
            p.required {{modeloLocal.tipoModelo === 'Modelo de Título Reurb' ? 'Modelo de Título' : 'Despacho'}}:
            validation-provider(rules="required", v-slot="{ errors }" name="Texto do modelo")
              app-editor-texto(
                :value="modeloLocal.textoModelo",
                @onTextChange="onTextChange",
                :class="{'erro' : errors.length}"
              )
              span.erro-mensagem(v-if="errors.length") {{ errors[0] }}
          div(v-if="modeloLocal.tipoModelo === 'Modelo de Título Reurb'").group
            p Assinaturas:&nbsp
            app-anexo(
              :files="imagensAssinaturas",
              :id="'upload-assinaturas-modelo-editar'",
              :tipoExibir="'ANEXO_ANALISE'",
              :fileType="['png', 'jpg', 'jpeg']",
              @uploadFile="uploadAssinatura",
              @downloadDocumentoCadastro="downloadDocumentoCadastro",
              @removeFile="removeAssinatura"
            )
      template(slot="footer")
        .flex-buttons
          el-button(@click="$emit('closeModal')") Cancelar &nbsp
            .fa.fa-times

          div
            el-button(
               v-if="modelo.tipoModelo === 'Modelo de Título Reurb'"
               :loading="loadingPrevisualizacao"
               :disabled="loadingPrevisualizacao"
               @click="preVisualizar()"
              ) Pré-visualizar &nbsp
              .fa.fa-eye(v-if="!loadingPrevisualizacao")

            salvar-modelo(
              v-if="modelo.situacao.toUpperCase() !== 'FINALIZADO'"
              v-model="updateModelo"
              @update:modelValue="updateModelo($event)"
            )

            el-button(
              v-if="modelo.tipoModelo === 'Modelo de Título Reurb'"
              type="success"
              @click="updateModelo($event, true)"
            ) Finalizar &nbsp
              .fa.fa-check

    app-modal-visualizar-modelo(
        v-if="showModalVisualizarModelo"
        :modelo="{ ...modelo, tipoModelo: 'Modelo de Título Reurb', textoModelo: textoModeloPrevisualizacao, assinaturas: imagensAssinaturas }"
        titulo="Pré-visualização do Modelo",
        ativaBotaoVoltar="true"
        @closeModal="showModalVisualizarModelo = false"
      )

</template>

<script>
import AppModal from '@/components/AppModal'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppAnexo from '@/components/AppAnexo'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import SalvarModelo from './SalvarModelo'
import AppModalVisualizarModelo from './AppModalVisualizarModelo.vue'
import { mapActions } from 'vuex'
import axios from '@/utils/api'
import FileSaver from 'file-saver'

export default {
  components: {
    AppModal,
    AppEditorTexto,
    AppAnexo,
    SalvarModelo,
    AppModalVisualizarModelo
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    modelo: {
      type: Object,
      required: true
    },
    titulo: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      municipios: [],
      reurbColetivos: [],
      imagensAssinaturas: [],
      modeloLocal: {
        tipoModelo: '',
        textoModelo: '',
        idMunicipio: null,
        idReurbColetivo: null,
        tipoReurb: null,
        nomeMunicipio: '',
        numeroProcessoReurbColetivo: '',
        documentos: [],
        assinaturas: []
      },
      showModalVisualizarModelo: false,
      textoModeloPrevisualizacao: '',
      loadingPrevisualizacao: false
    }
  },

  async mounted () {
    this.modeloLocal = { ...this.modelo }

    if (this.modeloLocal.tipoModelo === 'Modelo de Título Reurb' && process.env.ESTADO === 'ma') {
      await this.carregarDadosReurb()
    }

    if (this.modeloLocal.tipoModelo === 'Modelo de Título Reurb') {
      if (this.modeloLocal.documentos && this.modeloLocal.documentos.length > 0) {
        this.imagensAssinaturas = [...this.modeloLocal.documentos]
      } else if (this.modeloLocal.assinaturas && this.modeloLocal.assinaturas.length > 0) {
        this.imagensAssinaturas = [...this.modeloLocal.assinaturas]
      } else {
        this.imagensAssinaturas = []
      }
    }
  },

  computed: {
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    municipiosComSelecionado () {
      if (!this.modeloLocal.idMunicipio || !this.modeloLocal.nomeMunicipio) {
        return this.municipios
      }
      const municipioSelecionado = this.municipios.find(m => m.id === this.modeloLocal.idMunicipio)
      if (municipioSelecionado) {
        return this.municipios
      }
      return [
        ...this.municipios,
        { id: this.modeloLocal.idMunicipio, nome: this.modeloLocal.nomeMunicipio }
      ]
    },
    reurbColetivosComSelecionado () {
      if (!this.modeloLocal.idReurbColetivo || !this.modeloLocal.numeroProcessoReurbColetivo) {
        return this.reurbColetivos
      }
      const reurbSelecionado = this.reurbColetivos.find(r => r.id === this.modeloLocal.idReurbColetivo)
      if (reurbSelecionado) {
        return this.reurbColetivos
      }

      return [
        ...this.reurbColetivos,
        { id: this.modeloLocal.idReurbColetivo, numeroProcesso: this.modeloLocal.numeroProcessoReurbColetivo }
      ]
    }
  },

  methods: {
    ...mapActions({
      salvarModeloDespacho: 'modeloDespacho/salvarModeloDespacho',
      buscarReurbColetivosPorMunicipio: 'modeloDespacho/buscarReurbColetivosPorMunicipio',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual',
      previsualizarModelo: 'modeloDespacho/previsualizarModelo'
    }),

    async carregarDadosReurb () {
      if (this.isMaranhao) {
        const municipiosData = await this.findMunicipiosByEstadoAtual()
        this.municipios = municipiosData || []

        if (this.modeloLocal.idMunicipio) {
          await this.buscarReurbColetivos()
        }
      }
    },

    async buscarReurbColetivos () {
      if (this.modeloLocal.idMunicipio) {
        try {
          const response = await this.buscarReurbColetivosPorMunicipio(this.modeloLocal.idMunicipio)
          this.reurbColetivos = response || []
        } catch (error) {
          this.reurbColetivos = []
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar Reurb Coletivos')
        }
      } else {
        this.reurbColetivos = []
        this.modeloLocal.idReurbColetivo = null
      }
    },

    uploadAssinatura (file) {
      if (this.imagensAssinaturas.length < 6) {
        this.imagensAssinaturas.push({
          key: file.response,
          nome: file.name,
          tipo: {
            id: 343,
            codigo: 'ASSINATURA_SIMBOLICA'
          }
        })
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'É permitido no máximo 6 assinaturas!')
      }
    },

    removeAssinatura (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          const index = this.imagensAssinaturas.findIndex(a =>
            (a.id && a.id === documento.id) || (a.key && a.key === documento.key)
          )
          if (index > -1) {
            this.imagensAssinaturas.splice(index, 1)
          }
        },
        () => {}
      )
    },

    onTextChange (value) {
      this.modeloLocal.textoModelo = value
    },

    async preVisualizar () {
      this.loadingPrevisualizacao = true
      try {
        const response = await this.previsualizarModelo({ modelo: this.modeloLocal.textoModelo })
        this.textoModeloPrevisualizacao = response.modelo
        this.showModalVisualizarModelo = true
      } catch (error) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao gerar pré-visualização do modelo')
      } finally {
        this.loadingPrevisualizacao = false
      }
    },

    async updateModelo ($event, finalizar = false) {
      if ($event) {
        if (!(await this.$refs.validation.validate())) {
          this.showWarning('Para finalizar preencha os campos destacados.')
          return
        }

        const modeloEnvio = {
          id: this.modeloLocal.id,
          textoModelo: this.modeloLocal.textoModelo,
          assinaturas: this.imagensAssinaturas.length > 0 ? this.imagensAssinaturas : [],
          ...(this.modeloLocal.tipoModelo === 'Modelo de Título Reurb' && { situacao: finalizar ? 'FINALIZADO' : 'EM_ANDAMENTO' })
        }

        this.salvarModeloDespacho(modeloEnvio).then(() => {
          this.$emit('closeModal')
          this.$emit('updateAoEditar')
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Modelo editado com sucesso!')
        }).catch((error) => {
          const mensagemErro = error.response?.data?.message || error.response?.data?.userMessage || 'Erro ao editar o modelo'
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, mensagemErro)
        })
      }
    },

    async downloadDocumentoCadastro (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    }
  }
}
</script>

<style scoped lang="scss">
.group {
  padding: 30px;
}

.group:not(:first-child) {
  margin: 5px 0;
}

.group p.required:after {
  color: red;
  content: " *";
}

.campo-filtro-reurb {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.input-reurb {
  flex: 0 0 35%;
}

.flex-buttons {
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
}

.erro {
  border: solid 1px red;
  border-radius: 5px;
}

.erro-mensagem {
  color: #f56c6c;
  display: block;
  font-size: 13px;
  margin-top: 6px;
}

@media (max-width: 780px) {
  .modalModelo {
    position: fixed !important;
    width: 395px !important;
  }

  .campo-filtro-reurb {
    flex-direction: column;
    gap: 20px;
  }

  .input-reurb {
    flex: 1;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalEditarModelo.vue